const path = '/ava/comentarios';

const endpoint = {
  main: path,
};

export default endpoint;
